import { type ShopProduct } from "./types";

import mainComp from "./shop-product.vue";
import { createApp, h, reactive } from "vue";
import {
    type PaymentLogoKey,
    type PaymentMethodKey,
} from "../../checkout/payment-type/payment-method";
import { mountReplace } from "../../../../utilities/mount-replace";

export function init(
    Vue: never,
    sel: string,
    prod: ShopProduct,
    paymentKeys: (PaymentLogoKey | PaymentMethodKey)[]
) {
    prod = reactive(prod);
    const comp = createApp({
        render: function () {
            return h(mainComp, {
                product: prod,
                paymentKeys: paymentKeys,
            });
        },
    });
    mountReplace(comp, sel);
    return comp;
}
